import { render } from "./HelperClassComponent.vue?vue&type=template&id=315a8634"
import script from "./HelperClassComponent.vue?vue&type=script&lang=js"
export * from "./HelperClassComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__